import React from 'react'
import Modal from '../../../components/UI/UIModal'
import { Icon } from '../../../components/Icon'

interface DeleteModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  description: string
  onConfirm: () => void
  icon?: string
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  onConfirm,
  icon,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4">
        <div
          onClick={onClose}
          className="flex w-[100%] justify-end cursor-pointer"
        >
          <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
        </div>
        <div className="flex items-center w-[100%] justify-center">
          {icon && (
            <Icon name={icon} stroke={'#FF6666'} height={52} width={52} />
          )}
        </div>
        <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
          <h1 className={'text-text2 text-[18px] font-bold'}>{title}</h1>
          <p className={'text-[14px] text-text1 font-normal'}>{description}</p>
        </div>
        <button
          onClick={onConfirm}
          className="text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]"
        >
          Yes, I am Sure
        </button>
        <button
          onClick={onClose}
          className="text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]"
        >
          Cancel
        </button>
      </div>
    </Modal>
  )
}

export default DeleteModal
